import classnames from 'classnames';
import React, { cloneElement, FC } from 'react';
import { MenuItem } from 'react-contextmenu';
import { Text } from '../../index';
import styles from './ContextMenuItem.scss';
import { IOuter } from './ContextMenuItem.types';

export const ContextMenuItem: FC<IOuter> = ({
  title,
  titleTextSize = 'small',
  titleTextWeight = 'normal',
  titleClassName,
  icon,
  iconClassName,
  disabled,
  divider,
  hotKey,
  dataHook,
  dataMenuItemId,
  ellipsis,
  menuItemClassName,
  ...otherProps
}) => (
  <MenuItem
    {...otherProps}
    className={classnames(
      divider ? styles.divider : styles.menuItem,
      { [styles.disabled]: disabled },
      menuItemClassName,
    )}
    data-hook={dataHook}
  >
    <div className={styles.labelContainer} data-menu-item-id={dataMenuItemId}>
      {icon && cloneElement(icon, { className: classnames(styles.icon, iconClassName) })}
      <Text
        size={titleTextSize}
        weight={titleTextWeight}
        dataHook={dataHook}
        ellipsis={ellipsis}
        className={classnames(styles.label, titleClassName)}
      >
        {title}
      </Text>
    </div>

    <Text size="tiny" weight="normal" className={styles.hotKey}>
      {hotKey}
    </Text>
  </MenuItem>
);
